'use client';

import { c as _c } from "react/compiler-runtime";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@components/ui/tooltip';
import { cn } from 'cn';
import { ShieldCheck } from 'lucide-react';
import { verificationShieldActiveClassName } from './verification-shield-styles';
interface VerificationShieldIndicatorProps {
  label: string;
  className?: string;
}

/** Read-only verified shield for contact fields and similar surfaces. */
export function VerificationShieldIndicator(t0) {
  const $ = _c(11);
  const {
    label,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("ml-auto flex h-8 w-8 shrink-0 items-center justify-center rounded-md border", verificationShieldActiveClassName, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ShieldCheck className="h-4 w-4" aria-hidden={true} data-sentry-element="ShieldCheck" data-sentry-source-file="verification-shield-indicator.tsx" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label || $[4] !== t1) {
    t3 = <TooltipTrigger asChild={true} data-sentry-element="TooltipTrigger" data-sentry-source-file="verification-shield-indicator.tsx"><span role="status" aria-label={label} className={t1}>{t2}</span></TooltipTrigger>;
    $[3] = label;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== label) {
    t4 = <TooltipContent side="top" variant="small" data-sentry-element="TooltipContent" data-sentry-source-file="verification-shield-indicator.tsx">{label}</TooltipContent>;
    $[6] = label;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <TooltipProvider delayDuration={200} data-sentry-element="TooltipProvider" data-sentry-component="VerificationShieldIndicator" data-sentry-source-file="verification-shield-indicator.tsx"><Tooltip data-sentry-element="Tooltip" data-sentry-source-file="verification-shield-indicator.tsx">{t3}{t4}</Tooltip></TooltipProvider>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}